import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, KeyValueSet, KeyValues, LocalService, RelationShipRole, InteractionType, SeatsInitialization, SessionConfigType, TriggeredEvent, Status, ActiveSessions, KeyValues5 } from '../../../service/local.service';

@Component({
  selector: 'app-session-config',
  templateUrl: './session-config.component.html',
  styleUrls: ['./session-config.component.scss']
})
export class SessionConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["reservation", "table"]; maxBodyHeight = 0; isRedAlert = true; message = ''; queues: KeyValues5[];
  businessId = ''; seatId = ''; sessionConfigType: SessionConfigType; relationShipType: InteractionType = InteractionType.Business;
  relationShipRole: RelationShipRole = RelationShipRole.EndCustomer; selectedCount = 0; selectedToken = ''; isForceAttachBill = false;
  seats: SeatsInitialization; activeSessions: ActiveSessions; seatInfo: KeyValues3; isElligibleForBill = true;
  selectedUserId = ''; selectedQueueId = ''; userName = ''; selectedSeats: KeyValues[] = []; ignoreSessionIds: string[] = [];
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private billingManagementService: BillingManagementService, private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.message = '';
    switch (this.sessionConfigType) {
      case SessionConfigType.Add: {
        this.billingManagementService.getQueues(this.businessId).subscribe(result => {
          this.queues = result;
        });
        this.billingManagementService.getSeatsInitialization(this.businessId).subscribe(result => {
          this.seats = result;
        });
      } break;
      case SessionConfigType.View: {
        this.billingManagementService.getActiveSessions(this.businessId, true).subscribe(result => {
          this.activeSessions = result;
        });
      } break;
      case SessionConfigType.AttachBill:
      case SessionConfigType.Delete: {
        this.billingManagementService.getActiveSessions(this.businessId, false).subscribe(result => {
          this.activeSessions = result;
        });
      } break;
      case SessionConfigType.SeatInfo: {
        this.billingManagementService.getSessionBySeat(this.seatId).subscribe(result => {
          this.seatInfo = result.seat;
          this.activeSessions = {
            seats: [result.seats] as SeatsInitialization[],
            sessions: [result.session] as KeyValues5[]
          } as ActiveSessions;
        });
      } break;
    }
  }

  onGetHeader() {
    let rtn = '';
    switch (this.sessionConfigType) {
      case SessionConfigType.Add: {
        rtn = this.localService.languageContent.reservation.new_session;
      } break;
      case SessionConfigType.AttachBill: {
        rtn = this.localService.languageContent.reservation.attach_bill;
      } break;
      case SessionConfigType.View: {
        rtn = this.localService.languageContent.reservation.view_session;
      } break;
      case SessionConfigType.Delete: {
        rtn = this.localService.languageContent.reservation.clear_session;
      } break;
      case SessionConfigType.SeatInfo: {
        rtn = this.localService.languageContent.reservation.seat_info;
      } break;
    }
    return rtn;
  }

  onGetSeatArrangement(key): KeyValueSet[] {
    return this.seats.availablity.find(x => x.key == key).value;
  }

  onUserUpdated(e) {
    this.selectedUserId = e;
  }

  onSeatsSelected(e: string[], parentKey) {
    let item = this.selectedSeats.find(x => x.key == parentKey);
    if (item) {
      item.values = e;
    } else {
      this.selectedSeats.push({ key: parentKey, values: e } as KeyValues)
    }
    this.selectedCount = this.onGetCount();
  }

  onGetCount() {
    let count = 0;
    this.selectedSeats.forEach(x => {
      count += x.values.length;
    });
    return count;
  }

  onAction(index, key = '') {
    this.message = '';
    switch (index) {
      case 1: {
        if (this.selectedCount == 0) {
          this.message = this.localService.languageContent.reservation.minimum_one_required;
        } else {
          let user = { v1: this.selectedUserId, v2: this.userName, v3: this.selectedQueueId } as KeyValues3;
          let seats: string[] = [];
          this.selectedSeats.forEach(x => {
            seats.push(...(x.values));
          });
          this.billingManagementService.createSession(this.businessId, seats, user).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (this.selectedQueueId && (result.status == Status.Success || result.status == Status.Duplicate)) {
              this.queues = this.queues.filter(x => x.key != this.selectedQueueId);
              this.selectedQueueId = '';
            }
            if (result.status == Status.Success) {
              this.activeModal.close({ event: TriggeredEvent.Ok, data: result.id });
            }
          });
        }
      } break;
      case 2: {
        this.billingManagementService.clearSession(key).subscribe(result => {
          this.localService.showInformationByStatus(result);
          if (result == Status.Success) {
            this.activeSessions.sessions = this.activeSessions.sessions.filter(x => x.key != key);
            if (this.activeSessions.sessions.length == 0)
              this.activeModal.close({ event: TriggeredEvent.Ok });
          }
        });
      } break;
      case 3: {
        this.billingManagementService.getSeatsBySessionId(key).subscribe(result => {
          let item = this.activeSessions.seats.find(x => x.sessionKey == key);
          if (item) {
            item.availablity = result.availablity;
            item.groups = result.groups
          } else {
            this.activeSessions.seats.push(result);
          }
        });
      } break;
      case 4: {
        this.billingManagementService.clearSeat(key).subscribe(result => {
          this.localService.showInformationByStatus(result);
          if (result == Status.Success) {
            this.activeModal.close({ event: TriggeredEvent.Ok });
          }
        });
      } break;
      case 5: {
        this.selectedCount = this.activeSessions.sessions.filter(x => x.isSelected).length;
      } break;
      case 6: {
        if (this.selectedToken == '') {
          this.message = this.localService.languageContent.reservation.invalid_receipt_num;
        } else if (this.selectedCount == 0) {
          this.message = this.localService.languageContent.reservation.minimum_one_required;
        } else {
          let ids = this.activeSessions.sessions.filter(x => x.isSelected).map(x => x.key);
          this.billingManagementService.attachBill(this.businessId, this.selectedToken, ids, false).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.activeModal.close({ event: TriggeredEvent.Ok });
            } else if (result.status == Status.Invalid) {
              this.message = this.localService.languageContent.reservation.invalid_receipt_num;
            }
          });
        }
      } break;
      case 7: {
        this.selectedToken = key;
      } break;
      case 8: {
        this.billingManagementService.getBillsBySessionId(key).subscribe(result => {
          let item = this.activeSessions.bills.find(x => x.key == key);
          if (item) {
            item.value = result.value;
          } else {
            this.activeSessions.bills.push(result);
          }
        });
      } break;
      case 9: {

      } break;
      case 10: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, key]);
        this.activeModal.close({ event: TriggeredEvent.Close });
      } break;
    }
  }

  isSeatsLoaded(sessionKey): boolean {
    let item = this.activeSessions.seats.find(x => x.sessionKey == sessionKey);
    return item ? true : false;
  }

  isBillsLoaded(sessionKey): boolean {
    let item = this.activeSessions.bills.find(x => x.key == sessionKey);
    return item ? true : false;
  }

  onGetSeats(strSessionId): KeyValues3[] {
    if (this.activeSessions.seats) {
      let item = this.activeSessions.seats.find(x => x.sessionKey == strSessionId);
      return item ? item.groups : [];
    } else {
      return [];
    }
  }

  onGetBills(strSessionId): KeyValueSet[] {
    let rtn: KeyValueSet[] = [];
    if (this.activeSessions.bills) {
      let item = this.activeSessions.bills.find(x => x.key == strSessionId);
      if (item) {
        rtn = item.value;
      }
    }
    return rtn;
  }

  onDetachBill(sessionKey, billKey) {
    this.billingManagementService.detachBill(billKey, [sessionKey], false, this.businessId).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        let item = this.activeSessions.bills.find(x => x.key == sessionKey);
        if (item) {
          item.value = item.value.filter(x => x.key != billKey);
        }
      }
    });
  }

  onGetSeatArrangementBySessionId(strSessionId, key): KeyValueSet[] {
    return this.activeSessions.seats.find(x => x.sessionKey == strSessionId).availablity.find(x => x.key == key).value;
  }
}
